module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAKCAYAAACJxx+AAAAAvklEQVQoU5WPsQ4BYRCEZ/ZwEYWX0PjVSpWGRin/dQqVRiKiU2i8glI0dxeJSnQST4Fn8Aa4+FdOciKisdXM5svsLPExSVCdQFnMx6dZtmYm7rbWA3WZeo868MLzItUv4GprHaGuCOwd4AtQd+DIj44RE2saSt3x4dpOpCWEr+rWgBxE2eU9MBcB+7nouL0FZk5FqRCfhok1TaVuqIAQcOmpTyD12q7475K/gHfJ7JPvhP+BxJoxRMv58DzNUp8KAE2w+BqpVgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/charter/screen_icon_sheng.png
// module id = aEXR
// module chunks = 1